(function(){
    "use strict";

    angular
        .module('ccsTrApp')
        .service('MarketPriceCustomService', MarketPriceCustomService);

    MarketPriceCustomService.$inject = ['$http'];

    function MarketPriceCustomService($http) {
        var service = {
        };

        return service;
    }
})();
